import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { DEBUG, HOST } from "./settings";
import { getCookie } from "../utils";
import { ApiError } from "./types";

class Api {
  static handleError(error: any): ApiError {
    const err: ApiError = {
      msg: error?.response?.data || "unknown error",
      error,
    };
    if (DEBUG) {
      console.log("ApiError:", err);
    }
    return err;
  }

  static creds(): Record<string, string> {
    return { "x-auth": getCookie("token") };
  }

  static multipart(): Record<string, string> {
    return { "Content-Type": "multipart/form-data" };
  }

  static get(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${HOST}${url}`, {
          ...config,
          headers: { ...config?.headers, ...this.creds() },
        })
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(this.handleError(err));
        });
    });
  }

  static post<D>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${HOST}${url}`, data, {
          ...config,
          headers: { ...config?.headers, ...this.creds() },
        })
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(this.handleError(err));
        });
    });
  }

  static patch<D>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${HOST}${url}`, data, {
          ...config,
          headers: { ...config?.headers, ...this.creds() },
        })
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(this.handleError(err));
        });
    });
  }

  static delete(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${HOST}${url}`, {
          ...config,
          headers: { ...config?.headers, ...this.creds() },
        })
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(this.handleError(err));
        });
    });
  }

  static async getData<T>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<T> {
    return (await this.get(url, config)).data as T;
  }

  static async postData<T, D>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig
  ): Promise<T> {
    return (await this.post<D>(url, data, config)).data as T;
  }

  static async patchData<T, D>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig
  ): Promise<T> {
    return (await this.patch<D>(url, data, config)).data as T;
  }

  static async deleteData<T>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<T> {
    return (await this.delete(url, config)).data as T;
  }
}

export default Api;
